import type { WorklistTableAddendum } from '../types';

export const DraftTypeEnum = {
  REPORT: 'REPORT',
  ADDENDUM: 'ADDENDUM',
} as const;

export type DraftType = (typeof DraftTypeEnum)[keyof typeof DraftTypeEnum];

interface WorklistItemForDraftCheck {
  hasDraftReport?: Nullable<boolean>;
  report?: Nullable<{
    sentAt?: Nullable<string | Date>;
    addendums?: ReadonlyArray<{
      smid: string;
      sentAt?: Nullable<string | Date>;
    }>;
  }>;
}

interface WorklistItemDraftState {
  draftType: DraftType | null;
  draftedAddendum: WorklistTableAddendum | undefined;
}

export const getWorklistItemDraftState = (
  worklistItem: Nullable<WorklistItemForDraftCheck>
): WorklistItemDraftState => {
  // As of 1/27/26 we don't reset hasDraftReport when a report is sent, so we need to check sentAt as well
  const hasDraftReport = worklistItem?.hasDraftReport === true && !worklistItem?.report?.sentAt;

  const draftedAddendum = worklistItem?.report?.addendums?.find((addendum) => !addendum.sentAt) as
    | WorklistTableAddendum
    | undefined;

  const hasDraftAddendum = draftedAddendum != null;

  let draftType: DraftType | null = null;
  if (hasDraftReport) {
    draftType = DraftTypeEnum.REPORT;
  } else if (hasDraftAddendum) {
    draftType = DraftTypeEnum.ADDENDUM;
  }

  return {
    draftType,
    draftedAddendum,
  };
};
